import { setAttribute } from '..';
let videoFormat;
const supportsVideoType = (video, type) => {
    // Allow user to create shortcuts, i.e. just "webm"
    const formats = {
        ogg: 'video/ogg; codecs="theora"',
        h264: 'video/mp4; codecs="avc1.42E01E"',
        webm: 'video/webm; codecs="vp8, vorbis"',
        vp9: 'video/webm; codecs="vp9"',
        hls: 'application/x-mpegURL; codecs="avc1.42E01E"'
    };
    return video.canPlayType(formats[type] || type);
};
const getFullVideoUrl = (url, video) => {
    if (supportsVideoType(video, 'webm') === 'probably') {
        videoFormat = 'webm';
    }
    else {
        videoFormat = 'mp4';
    }
    return `${url}.${videoFormat}`;
};
const getVideoAdaptedToDevice = (src, node, isPoster) => {
    let url = '';
    for (const s of src) {
        const maxWidth = s.maxWidth;
        if ((maxWidth && window.innerWidth < maxWidth) || !maxWidth) {
            url = isPoster ? s.posterUrl : s.url;
            break;
        }
    }
    if (node.tagName === 'VIDEO' && !isPoster) {
        url = getFullVideoUrl(url, node);
    }
    return url;
};
export const videoAction = (node, src) => {
    if (Array.isArray(src)) {
        const video = getVideoAdaptedToDevice(src, node);
        const poster = getVideoAdaptedToDevice(src, node, true);
        setAttribute('src', node, video);
        setAttribute('poster', node, poster);
        return;
    }
    if (typeof src === 'string') {
        setAttribute('src', node, src);
        return;
    }
    const { url, posterUrl } = src;
    if (url) {
        setAttribute('src', node, getFullVideoUrl(url, node));
    }
    if (posterUrl) {
        setAttribute('poster', node, posterUrl);
    }
};
